import { tv } from 'tailwind-variants';

export const navItemStyles = tv({
  slots: {
    root: 'group hover:bg-gray-0 flex h-8 w-full cursor-pointer items-center gap-x-2 rounded-sm px-2 text-xs font-semibold',
    icon: 'mr-0 h-6 w-6',
    title: 'flex-1 text-xs first-letter:uppercase',
    itemIcon: '-mr-2 h-6 w-6',
  },
  variants: {
    active: {
      true: {
        root: 'bg-secondary-0 hover:bg-color-secondary-0/75',
      },
      false: {
        icon: 'fill-gray-7',
      },
    },
    light: {
      true: {},
    },
  },
  compoundVariants: [
    {
      active: false,
      light: true,
      class: {
        root: 'text-gray-7',
      },
    },
    {
      root: {
        active: false,
        light: false,
        class: {
          root: 'text-gray-9',
        },
      },
    },
  ],
  defaultVariants: {
    active: false,
    light: false,
  },
});
